import styled from 'styled-components';

export const AboutSection = styled.section`
  padding: 5rem 0;
  background: #f8fafc;
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;

  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  text-align: center;
  color: #197278;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 1.125rem;
  text-align: center;
  color: #64748b;
  margin-bottom: 4rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  margin-bottom: 4rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
    margin-bottom: 3rem;
  }
`;

export const PersonalInfo = styled.div`
  background: white;
  padding: 2.5rem;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  }
`;

export const AcademicInfo = styled.div`
  background: white;
  padding: 2.5rem;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  }
`;

export const InfoTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #197278;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;

  svg {
    font-size: 1.5rem;
  }
`;

export const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Name = styled.h4`
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 1rem;
`;

export const Description = styled.p`
  font-size: 1rem;
  line-height: 1.7;
  color: #475569;
`;

export const Degree = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;

  svg {
    color: #197278;
  }
`;

export const Institution = styled.div`
  font-size: 1.125rem;
  font-weight: 500;
  color: #475569;
  margin-bottom: 0.25rem;
`;

export const University = styled.div`
  font-size: 1rem;
  color: #64748b;
  font-style: italic;
`;

export const PhilosophySection = styled.div`
  background: linear-gradient(135deg, #197278 0%, #145A5A 100%);
  color: white;
  padding: 3rem;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 8px 25px #19727833;

  @media (max-width: 768px) {
    padding: 2rem;
  }
`;

export const PhilosophyIcon = styled.div`
  font-size: 3rem;
  color: #fbbf24;
  margin-bottom: 1.5rem;
`;

export const PhilosophyTitle = styled.h3`
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const PhilosophyText = styled.p`
  font-size: 1.125rem;
  line-height: 1.7;
  max-width: 800px;
  margin: 0 auto;
  opacity: 0.95;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`; 